import React from 'react';
import { format } from 'date-fns';
import { autobind } from 'core-decorators';
import List from 'src/componentes/list/tree';
import ListColumn from 'src/componentes/list/list-column';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import Avatar from 'src/componentes/avatar';
import AvatarGroup from 'src/componentes/AvatarGroup';
import Info from 'src/componentes/info';
import formatDateFns from 'src/utils/formatDateFns';

const ComunicadoRiscoEdit = React.lazy(() => import('./edit'));
@autobind
class ComunicadoEventoRiscoList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      saved: -1,
      savedAfterRemove: -1,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.refreshAfterRemove !== this.props.refreshAfterRemove) {
      this.setState({ saved: this.state.saved + 1 });
    }
  }

  handleCloseEdit(saved) {
    if (saved) {
      const refreshTemp = Math.random();
      this.props.refreshCount && this.props.refreshCount(refreshTemp);
      this.setState({ saved: refreshTemp });
    }
  }

  renderContentInfoStatus() {
    return (
      <div >
        {this.props.intl.formatMessage({
            id: 'hint.prontoEnvio',
          })}
      </div>
    )
  }

  renderDataEnvio(i) {
    if (!(i.dataEnvio && i.status?.id === 1)) return <div></div>;

    const { user } = this.props;
    const { currentDisplay, currentLocale } = formatDateFns(
      user?.idioma,
      true
    );

    return (
      <div>
        {format(new Date(i.dataEnvio), currentDisplay, {
          locale: currentLocale,
        })}
      </div>
    );
  }

  renderStatus(i) {
    return i.status?.id === 1 ? (
      this.props.intl.formatMessage({ id: 'enviado' })
    ) : (
      <>
        {this.props.intl.formatMessage({ id: 'prontoEnvio' })}
        <Info
          id="prontoEnvio"
          placement="right"
          renderContent={this.renderContentInfoStatus}
        />
      </>
    );
  }

  renderResponsavel(item) {
    return (
      <Avatar
        size={37}
        showLabel
        showTooltip
        foto={item?.responsavel?.fotoArquivo}
        label={item?.responsavel?.nome}
      />
    );
  }

  renderDestinatarios(item) {
    return (
      <AvatarGroup max={5} avatarSize={37}>
        {item.destinatarios.length > 0 &&
          item.destinatarios.map((c) => (
            <Avatar
              key={`avatar-${c.id}-${item.id}`}
              showTooltip
              id={`avatar-${c.id}-${item.id}`}
              foto={c.fotoArquivo}
              label={c.nome}
            />
          ))}
      </AvatarGroup>
    );
  }

  render() {
    const { disabled, intl } = this.props;
    return (
      <List
        editComponent={ComunicadoRiscoEdit}
        url="/EventoRiscoComunicado"
        showDelete={true}
        showExportItem={false}
        showExport={false}
        valueField="descricao"
        saved={this.state.saved}
        showNew={!disabled}
        showMenu={!disabled}
        parameters={{ eventoRiscoId: this.props.eventoRiscoId }}
        afterSave={this.props.refreshCount}
        afterDelete={this.props.refreshCount}
        local
        modelValue={this.props.model.value}
        dataSource={this.props.model.value}
        {...this.props}
      >
        <ListColumn
          key="titulo"
          headerText={intl.formatMessage({ id: 'titulo' })}
          valueField="titulo"
          required
        />
        <ListColumn
          key="responsavel"
          headerText={intl.formatMessage({ id: 'label.responsavel' })}
          valueField="responsavel"
          valueFunction={this.renderResponsavel}
          required
        />
        <ListColumn
          key="destinatarios"
          headerText={intl.formatMessage({ id: 'label.destinatarios' })}
          valueField="destinatarios"
          valueFunction={this.renderDestinatarios}
          required
        />
        <ListColumn
          key="dataEnvio"
          headerText={intl.formatMessage({ id: 'dataEnvio' })}
          valueField="dataEnvio"
          valueFunction={this.renderDataEnvio}
        />
        <ListColumn
          key="status"
          headerText={intl.formatMessage({ id: 'status' })}
          valueField="titulo"
          valueFunction={this.renderStatus}
        />
      </List>
    );
  }
}

function mapStateToProps(state) {
  return {
    resources: state.user.termos,
    user: state.user,
  };
}
export default injectIntl(connect(mapStateToProps)(ComunicadoEventoRiscoList));
